import { connect } from 'react-redux';

import NoSearchResultsFoundBlock from '../NoSearchResultsFoundBlock/NoSearchResultsFoundBlock';
import { generateListingPageUrlFromUCMSHierarchy } from '../../dataConverters/ucmsHierarchyConverter';
import { cdnUrl } from '../../../../utils/url/url';
import UISettings from '../../settings/UISettings';


const mapStateToProps = (state) => {
  const noSearchResultsSegmentsIdsFromSettings = UISettings.get('no.search.results.segments.ids');
  let segmentsToShow = [];

  if (Array.isArray(noSearchResultsSegmentsIdsFromSettings) && noSearchResultsSegmentsIdsFromSettings.length > 0) {
    segmentsToShow = noSearchResultsSegmentsIdsFromSettings.map(
      (segmentId) => state.listingPage.staticData.ucmsHierarchy.segments.find((segmentData) => segmentData.id === segmentId)
    );
  } else {
    segmentsToShow = state.listingPage.staticData.ucmsHierarchy.segments.slice(0, 10);
  }

  return {
    tryAgainLabel: 'Please try again, we recommend:', // TODO: add to translations
    firstListItemLabel: 'Making sure the spelling is correct', // TODO: add to translations
    secondListItemLabel: 'Keeping your search simple (1 or 2 words will do)', // TODO: add to translations
    categoryListHeaderLabel: 'Or try one of these categories:', // TODO: add to translations
    categories: segmentsToShow.map((segmentData) => ({
      link: generateListingPageUrlFromUCMSHierarchy(segmentData.id, state.listingPage.staticData.ucmsHierarchy),
      image: segmentData.src || cdnUrl('/img/currys_logo_small.png'),
      label: segmentData.name
    })),
    categoriesPerRow:
    (state.listingPage.browser.device.deviceType === 'mobile' && 3) ||
    (state.listingPage.browser.device.deviceType === 'tablet' && 5) || 10
  };
};

export default connect(mapStateToProps)(NoSearchResultsFoundBlock);
